import { regionFixedExchangeRate } from 'services/config/region';
import { find } from 'lodash-es';

export const getCurrencySymbol = (currency: unknown): string => {
  if (typeof currency !== 'string' || !currency) {
    return '';
  }
  return (
    find(regionFixedExchangeRate, (value) => value?.shorthand === currency)?.symbol || currency
  );
};
